import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const BirthdayCake: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 21C1.44772 21 1 21.4477 1 22C1 22.5523 1.44772 23 2 23V21ZM22 23C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21V23ZM2 23H22V21H2V23Z"
        fill={color}
      />
      <path d="M19 22V16M5 16V22" stroke={color} strokeWidth="2" />
      <path
        d="M3 12.5V15.3929C3 16.1336 3.73991 16.5509 4.35163 16.1332C5.31346 15.4764 6.44283 14.7273 7.15385 14.7273C8.53846 14.7273 9.92308 17 11.7692 17C13.6154 17 13.6154 14.7273 15.4615 14.7273C16.5371 14.7273 18.3308 15.6916 19.7016 16.3913C20.3216 16.7077 21 16.2608 21 15.5647V12.5C21 12.2239 20.7761 12 20.5 12H3.5C3.22386 12 3 12.2239 3 12.5Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M19 12V8.5C19 8.22386 18.7761 8 18.5 8H16.5C16.2239 8 16 8.22386 16 8.5V11.6"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M13.5 12V8.5C13.5 8.22386 13.2761 8 13 8H11C10.7239 8 10.5 8.22386 10.5 8.5V11.6"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M8 12V8.5C8 8.22386 7.77614 8 7.5 8H5.5C5.22386 8 5 8.22386 5 8.5V11.6"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M16 5.5C16 5.83579 16.7047 6.42999 17.2268 6.8093C17.3901 6.92795 17.6099 6.92795 17.7732 6.8093C18.2953 6.42999 19 5.83579 19 5.5C19 5.19864 18.4324 3.93236 17.9386 2.89851C17.7611 2.52671 17.2389 2.52671 17.0614 2.89851C16.5676 3.93236 16 5.19864 16 5.5Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M10.5 5.5C10.5 5.83579 11.2047 6.42999 11.7268 6.8093C11.8901 6.92795 12.1099 6.92795 12.2732 6.8093C12.7953 6.42999 13.5 5.83579 13.5 5.5C13.5 5.19864 12.9324 3.93236 12.4386 2.89851C12.2611 2.52671 11.7389 2.52671 11.5614 2.89851C11.0676 3.93236 10.5 5.19864 10.5 5.5Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M5 5.5C5 5.83579 5.70474 6.42999 6.22679 6.8093C6.39009 6.92795 6.60991 6.92795 6.77321 6.8093C7.29526 6.42999 8 5.83579 8 5.5C8 5.19864 7.4324 3.93236 6.93863 2.89851C6.76106 2.52671 6.23894 2.52671 6.06137 2.89851C5.5676 3.93236 5 5.19864 5 5.5Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default BirthdayCake;
